function sortVolumes(volumes) {
  const sortOrder = ["XXS", "XS", "S", "M", "L", "XL"];

  return sortOrder.filter((item) => volumes.includes(item));
}

export { sortVolumes };
